// extracted by mini-css-extract-plugin
export default {"NumericRangeFeature":"vy_a bhf_b bhf_wb"};